var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71716 10.7114C2.87337 10.8676 3.12663 10.8676 3.28284 10.7114L5.82843 8.16583C5.98464 8.00962 5.98464 7.75635 5.82843 7.60014C5.67222 7.44393 5.41895 7.44393 5.26274 7.60014L3 9.86289L0.737258 7.60014C0.581048 7.44393 0.327783 7.44393 0.171573 7.60014C0.0153632 7.75635 0.0153632 8.00962 0.171573 8.16583L2.71716 10.7114ZM2.6 1L2.6 10.4286H3.4L3.4 1H2.6Z",
    fill: "#667689"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28284 0.71632C9.12663 0.56011 8.87337 0.56011 8.71716 0.71632L6.17157 3.2619C6.01536 3.41811 6.01536 3.67138 6.17157 3.82759C6.32778 3.9838 6.58105 3.9838 6.73726 3.82759L9 1.56485L11.2627 3.82759C11.419 3.9838 11.6722 3.9838 11.8284 3.82759C11.9846 3.67138 11.9846 3.41811 11.8284 3.2619L9.28284 0.71632ZM9.4 10.4277L9.4 0.999163H8.6L8.6 10.4277H9.4Z",
    fill: "#667689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/Sorting.fb374aaff1dd76a5ac21c68cc5fbb5f0.svg";
export { ForwardRef as ReactComponent };